var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle212(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "147.6559167174017 678.4382348401281 19.484083282598277 19.753684035895617",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M163.14,688.5c-.06,3.34-2.55,5.77-5.85,5.69-3.21-.08-5.75-2.77-5.63-5.98.12-3.2,2.84-5.85,5.92-5.77,3.15.08,5.61,2.76,5.55,6.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle212);
export default __webpack_public_path__ + "static/media/twinkle-2-12.3cb790627ff4fe2a5971fa4659574f1b.svg";
export { ForwardRef as ReactComponent };